import { createJSONStorage, persist } from "zustand/middleware";
import { createWithEqualityFn as create } from "zustand/traditional";

interface ExceptionVisibilityStore {
  visibility: boolean;
  setVisibility: (visible: boolean) => void;
}

export const useExceptionVisibilityStore = create<ExceptionVisibilityStore>()(
  persist(
    (set) => ({
      visibility: false,
      setVisibility: (visibility: boolean) => set({ visibility }),
    }),
    {
      name: `prelude:exception-visibility`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

interface CardVisibilityStore {
  visibility: boolean;
  setVisibility: (visible: boolean) => void;
}

export const useDisconnectedCardVisibilityStore = create<CardVisibilityStore>()(
  persist(
    (set) => ({
      visibility: true,
      setVisibility: (visibility: boolean) => set({ visibility }),
    }),
    {
      name: `prelude:disconnected-card-visibility`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
